<template>
  <div class="otherScenes-container">
    <div class="pc d-none d-lg-block">
      <div class="container" data-aos="fade-left" :data-aos-duration="2 * 1000">
        <div class="left">
          <img src="~assets/img/solution/otherScenes.png" alt="" />
        </div>
        <div class="right">
          <p class="intelligent-double-recording">其他场景</p>
          <p class="subtitle">Zealcomm还为政务、医疗、教育、集团企业提供音视频场<br />景建设方案。</p>
          <p class="btn-text" @click="open">了解更多 →</p>
        </div>
      </div>
    </div>
    <div class="d-lg-none mobile">
      <div class="container" data-aos="fade-left" :data-aos-duration="2 * 1000">
        <div class="top">
          <p class="title">其他场景</p>
          <p class="subtitle">Zealcomm还为政务、医疗、教育、集团企业提供音视频场景建设方案。</p>
          <p class="btn-text" @click="open">了解更多 →</p>
        </div>
        <div class="bottom">
          <img src="~assets/img/solution/otherScenes-mobile.png" alt="" />
        </div>
      </div>
    </div>
    <Form v-model="show" />
  </div>
</template>

<script>
  import Form from "@/components/Form/index.vue";
  export default {
    data() {
      return {
        show: false,
      };
    },
    components: {
      Form,
    },
    methods: {
      open() {
        if (typeof this.customBtnClick === "function") {
          this.customBtnClick.call();
        } else {
          this.show = true;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .otherScenes-container {
    background-color: #f5f5f7;
    .pc {
      .container {
        display: flex;
        justify-content: space-between;
        padding: 97px 0 149px;
        .left {
          flex: 1;
          img {
            width: 500px;
            height: 336px;
          }
        }

        .right {
          flex: 1;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #363636;
          margin: 9px 0 0 130px;
          .intelligent-double-recording {
            font-size: 30px;
            font-weight: 500;
          }
          .subtitle {
            text-align: left;
            margin-top: 32px;
            font-size: 18px;
            font-weight: 400;
          }
          .btn-text {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #08c6ad;
            cursor: pointer;
            margin-top: 45px;
          }
        }
      }
    }
    .mobile {
      .container {
        padding: 40px 0 80px;
        .top {
          font-family: PingFangSC-Medium, PingFang SC;
          color: #363636;
          margin-left: 19px;
          .title {
            font-size: 18px;
            font-weight: 500;
          }
          .subtitle {
            text-align: left;
            font-size: 13px;
            font-weight: 400;
            padding: 18px 42px 0 0;
          }
          .btn-text {
            width: 102px;
            height: 24px;
            border-radius: 3px;
            border: 1px solid #0ab49e;
            margin-top: 16px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #08c6ad;
            text-align: center;
          }
        }
        .bottom {
          margin: 30px 19px 0 20px;
          img {
            width: 336px;
            height: 189px;
          }
        }
      }
    }
  }
</style>
